/**
 * Gera e baixa um arquivo .xlsx a partir de linhas já no formato final
 * (uma linha por objeto, chaves = cabeçalhos das colunas).
 *
 * Centraliza só a parte mecânica (montar a planilha, nomear o arquivo,
 * disparar o download) - o mapeamento de colunas continua em cada tela,
 * porque cada grid tem um conjunto de campos diferente.
 *
 * A biblioteca xlsx (~280 KB) é carregada só aqui, no primeiro clique em
 * exportar - fora do bundle que todo mundo baixa ao abrir o sistema.
 *
 * @returns false quando não há nada para exportar (chamador decide o aviso).
 */
export async function exportarParaExcel(
  linhas: Record<string, unknown>[],
  nomeBaseDoArquivo: string,
  nomeDaAba = 'Dados'
): Promise<boolean> {
  if (linhas.length === 0) return false;

  const XLSX = await import('xlsx');

  const planilha = XLSX.utils.json_to_sheet(linhas);
  const livro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(livro, planilha, nomeDaAba);

  const hoje = new Date().toISOString().split('T')[0];
  XLSX.writeFile(livro, `${nomeBaseDoArquivo}_${hoje}.xlsx`);

  return true;
}
